import {IAgencyLineItem, IAgencyLineItemImperial} from "@/modules/lcca/interfaces/lccaCalculated";

export const calculateAgencyCost = function(lineItems: IAgencyLineItemImperial[]){

  const itemCosts = lineItems.map(L => {
    return L.unitCost * L.quantity
  });

  return itemCosts.reduce((a,b) => a + b, 0)
};
